import { render, staticRenderFns } from "./ProductSearchPage.vue?vue&type=template&id=07c461e0&scoped=true&lang=pug&"
import script from "./ProductSearchPage.vue?vue&type=script&lang=ts&"
export * from "./ProductSearchPage.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSearchPage.vue?vue&type=style&index=0&id=07c461e0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c461e0",
  null
  
)

export default component.exports